import { NoticeModal, Stack, Text } from '@pairy/pds-react';

import { SetState } from '@/types/helper';
import { Z_INDEX } from '@/constants/zIndex';

interface Props {
  isOpen: boolean;
  setIsOpen: SetState<boolean>;
  handleConfirmButtonClick: () => void;
}

// yearly 고객은 업그레이드가 안되기 때문에 안내 문구 작성
const PreventUpgradeModal = ({
  isOpen,
  setIsOpen,
  handleConfirmButtonClick,
}: Props) => {
  return (
    <NoticeModal
      title="플랜 변경 안내"
      isOpen={isOpen}
      onOpenChange={(open: boolean) => setIsOpen(open)}
      buttonType="success"
      buttonText="확인했습니다"
      handleButtonClick={handleConfirmButtonClick}
      zIndex={Z_INDEX.rootModal}
    >
      <Stack gap={16} direction="column">
        <Text variant="xl-medium" textAlign="center">
          연간 플랜 사용 중 플랜 업그레이드는
          <br />
          채널톡 상담을 통해서만 가능합니다.
        </Text>
        <Text variant="md-medium" color="zinc_500" textAlign="center">
          우측 하단의 채널톡을 클릭하여 <br /> 변경하고 싶으신 플랜과 함께
          메시지를 남겨주시면 <br />
          신속히 처리해드리도록 하겠습니다.
        </Text>
      </Stack>
    </NoticeModal>
  );
};

export default PreventUpgradeModal;
